import { blue } from "@mui/material/colors";

// Shared chat colors (bubbles, typing dot, scrollbar). Light mode keeps the MUI blue the
// chat was designed around; dark mode uses the stock dark primary, which takes dark text.
const isDark = (theme) => theme.palette.mode === "dark";

export const chatAccent = (theme) =>
  isDark(theme) ? theme.palette.primary.main : blue[700];

export const chatAccentHover = (theme) =>
  isDark(theme) ? theme.palette.primary.light : blue[800];

export const chatAccentActive = (theme) =>
  isDark(theme) ? theme.palette.primary.dark : blue[900];

// Text/icons sitting on the accent fill.
export const chatOnAccent = (theme) =>
  isDark(theme)
    ? theme.palette.primary.contrastText
    : theme.palette.common.white;

// Thin blue scrollbar used by the chat message lists.
export const chatScrollbarSx = {
  "&::-webkit-scrollbar": { width: "10px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: chatAccent,
    borderRadius: "0px",
    border: "none",
  },
  "&::-webkit-scrollbar-thumb:hover": { background: chatAccentHover },
  "&::-webkit-scrollbar-thumb:active": { background: chatAccentActive },
  "&::-webkit-scrollbar-corner": { background: "transparent" },
  scrollbarWidth: "thin",
  scrollbarColor: (theme) => `${chatAccent(theme)} transparent`,
};
